<div [nbSpinner]="loading" style="min-height: 200px">
    <ng-container *ngIf="games?.length">
        <div class="d-flex flex-wrap mb-2 full-bracket">
            <p class="paragraph m-0">{{ "GENERAL.BRACKET-DESCRIPTION" | translate }}</p>
            <button
                nbButton
                class="d-block ml-auto"
                status="primary"
                size="small"
                (click)="openGameBracket()"
                *ngIf="estrutura === 1"
            >
                {{ "GENERAL.VIEW-FULL-BRACKET" | translate }}
                <nb-icon icon="expand-outline"></nb-icon>
            </button>
        </div>

        <ng-container *ngIf="estrutura === 0">
            <nb-accordion multi>
                <nb-accordion-item *ngFor="let phase of games">
                    <nb-accordion-item-header>
                        {{ phase.titulo_sub_caixa }}
                        <span class="small ml-2 mt-1" *ngIf="phase.dt_inicio"
                            >{{ phase.dt_inicio }} / {{ phase.dt_final }}</span
                        >
                    </nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <nb-card *ngFor="let game of phase.dados_sub_caixa" class="nb-card-primary">
                            <nb-card-header>
                                <p class="m-0">{{ "GAME.GAME-DATE" | translate }}: {{ game.dt_jogo }}</p>
                            </nb-card-header>
                            <nb-card-body>
                                <nb-list>
                                    <nb-list-item
                                        *ngFor="let participantGroup of game.participantGroup"
                                        class="justify-content-between align-items-center position-relative"
                                        [class.winner]="game.lado_vencedor === participantGroup.lado"
                                    >
                                        <div class="participant">
                                            <nb-user
                                                *ngFor="let participant of participantGroup.participants"
                                                [picture]="participant.url_avatar"
                                                [name]="participant.nome"
                                            ></nb-user>
                                        </div>
                                        <div class="result">
                                            <span
                                                *ngFor="let result of participantGroup.result"
                                                [class.sup]="result.tipo_set === '1'"
                                                >{{
                                                    result.resultado || result.resultado === ""
                                                        ? result.resultado
                                                        : result
                                                }}</span
                                            >
                                        </div>
                                        <div
                                            class="triangle"
                                            *ngIf="game.lado_vencedor === participantGroup.lado"
                                        ></div>
                                    </nb-list-item>
                                </nb-list>
                            </nb-card-body>
                            <nb-card-footer>
                                <strong>{{ game.local.nome_local }}</strong> / <span>{{ game.local.endereco }}</span>
                            </nb-card-footer>
                        </nb-card>
                    </nb-accordion-item-body>
                </nb-accordion-item>
            </nb-accordion>
        </ng-container>
        <ng-container *ngIf="estrutura === 2">
            <div *ngFor="let groupPhase of games" class="mb-4">
                <ng-template [ngIf]="groupPhase.tipo_calculo === '0'" [ngIfElse]="bracket">
                    <h3>
                        {{ groupPhase.titulo_caixa }}
                        <span class="small">{{ groupPhase.dt_inicio }} / {{ groupPhase.dt_final }}</span>
                    </h3>
                    <nb-accordion multi>
                        <nb-accordion-item
                            *ngFor="let phase of groupPhase.dados_caixa"
                            (click)="verifyNeedOfGameRequest(phase)"
                            #item
                        >
                            <nb-accordion-item-header
                                >{{ phase.titulo_sub_caixa }}
                                <span *ngIf="phase.dt_inicio" class="small ml-2 mt-1"
                                    >{{ phase.dt_inicio }} à {{ phase.dt_final }}
                                </span>
                            </nb-accordion-item-header>
                            <nb-accordion-item-body>
                                <!-- QUANDO EXISTE DADOS_SUB_CAIXA -->
                                <nb-card *ngFor="let game of phase.dados_sub_caixa" accent="primary">
                                    <nb-card-header>
                                        <p class="m-0">{{ "GAME.GAME-DATE" | translate }}: {{ game.dt_jogo }}</p>
                                    </nb-card-header>
                                    <nb-card-body>
                                        <nb-list>
                                            <nb-list-item
                                                *ngFor="let participantGroup of game.participantGroup"
                                                class="justify-content-between align-items-center position-relative"
                                                [class.winner]="game.lado_vencedor === participantGroup.lado"
                                            >
                                                <div class="participant">
                                                    <nb-user
                                                        *ngFor="let participant of participantGroup.participants"
                                                        [picture]="participant.url_avatar"
                                                        [name]="participant.nome"
                                                    ></nb-user>
                                                </div>
                                                <div class="result">
                                                    <span
                                                        *ngFor="let result of participantGroup.result"
                                                        [class.sup]="result.tipo_set === '1'"
                                                    >
                                                        <!-- prettier-ignore -->
                                                        {{ result.resultado || result.resultado === "" ? result.resultado : result }}
                                                    </span>
                                                </div>
                                                <div
                                                    class="triangle"
                                                    *ngIf="game.lado_vencedor === participantGroup.lado"
                                                ></div>
                                            </nb-list-item>
                                        </nb-list>
                                    </nb-card-body>
                                    <nb-card-footer>
                                        <strong>{{ game.local.nome_local }}</strong> /
                                        <span>{{ game.local.endereco }}</span>
                                    </nb-card-footer>
                                </nb-card>

                                <!-- CASO CONTRARIO BUSCA NA API -->
                                <div *ngIf="item.expanded">
                                    <nb-card
                                        *ngFor="let game of gamesRequest[phase.game_id.id_parametro] | async"
                                        accent="primary"
                                    >
                                        <nb-card-header>
                                            <p class="m-0">{{ "GAME.GAME-DATE" | translate }}: {{ game.dt_jogo }}</p>
                                        </nb-card-header>
                                        <nb-card-body>
                                            <nb-list>
                                                <nb-list-item
                                                    *ngFor="let participantGroup of game.participantGroup"
                                                    class="justify-content-between align-items-center position-relative"
                                                    [class.winner]="game.lado_vencedor === participantGroup.lado"
                                                >
                                                    <div class="participant">
                                                        <nb-user
                                                            *ngFor="let participant of participantGroup.participants"
                                                            [picture]="participant.url_avatar"
                                                            [name]="participant.nome"
                                                        ></nb-user>
                                                    </div>
                                                    <div class="result">
                                                        <span
                                                            *ngFor="let result of participantGroup.result"
                                                            [class.sup]="result.tipo_set === '1'"
                                                        >
                                                            <!-- prettier-ignore -->
                                                            {{ result.resultado || result.resultado === "" ? result.resultado : result }}
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="triangle"
                                                        *ngIf="game.lado_vencedor === participantGroup.lado"
                                                    ></div>
                                                </nb-list-item>
                                            </nb-list>
                                        </nb-card-body>
                                        <nb-card-footer>
                                            <strong>{{ game.local.nome_local }}</strong> /
                                            <span>{{ game.local.endereco }}</span>
                                        </nb-card-footer>
                                    </nb-card>
                                </div>
                            </nb-accordion-item-body>
                        </nb-accordion-item>
                    </nb-accordion>
                </ng-template>
                <ng-template #bracket>
                    <h3>
                        {{ groupPhase.titulo_caixa }}
                        <span class="small">{{ groupPhase.dt_inicio }} / {{ groupPhase.dt_final }}</span>
                    </h3>
                    <app-games-bracket [games]="groupPhase.dados_caixa"></app-games-bracket>
                </ng-template>
            </div>
        </ng-container>
        <ng-container *ngIf="estrutura === 1">
            <app-games-bracket [games]="games"></app-games-bracket>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="!games">
        <h2 class="not-found">
            Ops!
            <br />
            <span>{{ "MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate }}</span>
        </h2>
    </ng-container>
</div>
<ng-template #gamesBracketTemplate let-data>
    <app-games-bracket [games]="data" [windowRef]="windowRef"></app-games-bracket>
</ng-template>
